const config = {
    API_URL: process.env.REACT_APP_API_URL,
    PUB_ACC_TOKEN: process.env.REACT_APP_PUB_ACC_TOKEN || '',
    BR_BASENAME: process.env.REACT_APP_BR_BASENAME || '/',
};

export default config;
